import { PERMISSION_REQUEST, PERMISSIONS_SHOW, PERMISSIONS_LIST, PERMISSIONS_EDIT, PERMISSIONS_CLEAR, PERMISSIONS_DELETE, PERMISSION_FAIL } from "../store/config";

const permissionInit = {
	isFetching: false,
	list: [],
	pages:{
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	edit: {},
	permissions: [],
	error: undefined
};

const permissions = (state=permissionInit,action) => {
	switch (action.type){
		case PERMISSION_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PERMISSIONS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PERMISSIONS_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case PERMISSIONS_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PERMISSIONS_CLEAR:
			return {
				...state,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PERMISSIONS_DELETE:
			return {
				...state,
				isFetching: action.isFetching,
				delete: action.payload,
				timestamp: action.timestamp
			}
		case PERMISSION_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default permissions;


// WEBPACK FOOTER //
// ./src/reducers/permissions.js